import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MarketplaceAssetModule } from '@platform-frontend/marketplace';
import { ButtonModule, CommonWordingModule, FormsModule, LoadingIndicatorModule, TemplateVariablesModule } from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { SubscriptionCancelConfirmationComponent } from './subscription-cancel-confirmation/subscription-cancel-confirmation.component';

@NgModule({
  declarations: [SubscriptionCancelConfirmationComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    FormsModule,
    LoadingIndicatorModule,
    MarketplaceAssetModule,
    MatomoTrackClickDirective,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TemplateVariablesModule,
    TranslocoModule
  ],
  exports: [SubscriptionCancelConfirmationComponent]
})
export class CheckoutAssetModule {}
